export default [
	//这个不能去掉
	{
		path: '/codeCallback'
	},
]
